import { themeGet } from 'styled-system';

export default `
::-webkit-scrollbar {
  width: 0;
}

*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Lato', sans-serif;
}

html, body, #root {
  overflow: hidden;
  width: 100%;
  height: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-overflow-scrolling: touch;
  overflow: -moz-scrollbars-none;
}

@-moz-document url-prefix() {
  html,body{overflow: hidden !important;}
}

html, body,
#root, #root > main {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

input {
  -webkit-border-radius: 0;
border-radius: 0;
-webkit-box-shadow: none;
box-shadow: none;
}

input:-ms-input-placeholder {
  color: rgba(218, 225, 231, 1);
}

input[type=checkbox]::checked {
  border-color: transparent;
  background-color: #ef5753;
  background-image: url("data:image/svg+xml;utf8,<svg viewBox='0 0 10 9' xmlns='http://www.w3.org/2000/svg'><path d='M1 4.88l2.378 2.435L9.046 1.6' stroke-width='1.6' stroke='%23FFF' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-position: center center;
  background-size: 80%;
  background-repeat: no-repeat;
}

input[type=checkbox]::-ms-check {
  min-width: 24px;
  min-height: 24px;
  margin: 0 ${themeGet('space.2')}px;
  appearance: none;
  outline: none;
  box-shadow: 0 2px 6px rgba(184, 194, 204, 0.25);
  border: 1px solid rgba(218, 225, 231, 1);
  border-radius: 50%;
  cursor: pointer;
}


a {
  text-decoration: none;
  color: inherit;
}

`;



// WEBPACK FOOTER //
// ../shop_main/util/globalstyle.js